import { useGetOne, useRecordContext } from "ra-core";
import { Link } from "react-router";
import { ChevronRight } from "lucide-react";

import { CompanyAvatar } from "../companies/CompanyAvatar";
import type { Company, Contact } from "../types";

// LDF: Pfad über dem Kontakt – zurück zur Kontaktübersicht oder zur Firma (Reiter Kontakte).

export const ContactBreadcrumb = () => {
  const record = useRecordContext<Contact>();
  const { data: company } = useGetOne<Company>(
    "companies",
    { id: record?.company_id as number },
    { enabled: record?.company_id != null },
  );
  if (!record) return null;
  return (
    <nav className="mb-3 flex flex-wrap items-center gap-1 text-sm text-muted-foreground" aria-label="Pfad">
      <Link to="/contacts" className="hover:text-foreground hover:underline">
        Kontakte
      </Link>
      {company && (
        <>
          <ChevronRight className="h-3.5 w-3.5" />
          <Link
            to={`/companies/${company.id}/show/contacts`}
            className="inline-flex items-center gap-1.5 font-medium text-foreground hover:underline"
            title="Zur Firma"
          >
            <CompanyAvatar record={company} width={20} height={20} />
            {company.name}
          </Link>
        </>
      )}
      <ChevronRight className="h-3.5 w-3.5" />
      <span className="truncate">
        {[record.academic_title, record.first_name, record.last_name].filter(Boolean).join(" ")}
      </span>
    </nav>
  );
};
